import { gql } from '$lib/apollo';

export const GET_COACHING = gql`
  query getCoaching($id: UUID!) {
    coaching(id: $id) {
      id
      state
      isHost
      isAttendee
      durationSeconds
      attendee {
        id
        slug
        name
        avatar {
          original {
            url
          }
        }
        discord {
          id
          username
          discriminator
        }
      }
      host {
        id
        slug
        name
        avatar {
          original {
            url
          }
        }
        cover {
          original {
            url
          }
        }
        discord {
          id
          username
          discriminator
        }
        # testimonialRequest {
        #   id
        # }
      }
      game {
        id
        slug
        localizedTitles {
          en
        }
        logoMain {
          original {
            url
          }
        }
        artwork {
          original {
            url
          }
        }
      }
      product {
        id
        name
        price
        description
        cover {
          original {
            url
          }
        }
        orderItem {
          id
          state
          total
          refunded {
            value
          }
        }
        addons {
          id
          name
          price
          description
        }
      }
      sessions {
        id
        name
        state
        description
      }
      intakeQuestions {
        id
        question
        answer
      }
    }
  }
`;
